export const ROOT = 'common/login';

export const FETCH_LOGIN_REQUEST = `${ROOT}/FETCH_LOGIN_REQUEST`;
export const FETCH_LOGIN_FAILURE = `${ROOT}/FETCH_LOGIN_FAILURE`;
export const FETCH_LOGIN_SUCCESS = `${ROOT}/FETCH_LOGIN_SUCCESS`;

export const CLEAR_LOGIN_DATA = `${ROOT}/CLEAR_LOGIN_DATA`;